import { addModulePrefix as p } from "../helpers"

// Signal actions for Sagas (do not change the store)
export const INIT_FORM = p(`INIT_FORM`)
export const SUBMIT_FORM = p(`SUBMIT_FORM`)

// Actions for reducer (change store)
export const LOAD_PERMISSIONS_STARTED = p(`LOAD_PERMISSIONS_STARTED`)
export const LOAD_PERMISSIONS_COMPLETED = p(`LOAD_PERMISSIONS_COMPLETED`)
export const LOAD_PERMISSIONS_FAILED = p(`LOAD_PERMISSIONS_FAILED`)
